import React from 'react';
import { inputCls, Label, SelectIcon } from './sharedVendorUI';

/**
 * Nature of Group -> Master Group -> Sub Group cascading selects, shared by both
 * the Supplier/Trading and Service Provider vendor forms. Sub Group is only shown
 * (and only required) once the selected Master Group actually has sub-groups.
 */
const GroupCascadeFields = ({
    natureOfGroups, natureLoading, natureGroupId, onNatureChange,
    masterGroups, masterLoading, groupId, onGroupChange,
    subGroups, subLoading, subGroupId, onSubGroupChange,
    disabled,
}) => {
    const showSubGroup = subGroups.length > 0;

    return (
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
                <Label required>Nature of Group</Label>
                <div className="relative">
                    <select
                        className={`${inputCls} appearance-none pr-10`}
                        value={natureGroupId}
                        onChange={(e) => onNatureChange(e.target.value)}
                        disabled={natureLoading || disabled}
                    >
                        <option value="">{natureLoading ? 'Loading…' : '-Please Select-'}</option>
                        {natureOfGroups.map((n) => (
                            <option key={n.NatureGroupId} value={n.NatureGroupId}>{n.NatureGroupName}</option>
                        ))}
                    </select>
                    <SelectIcon loading={natureLoading} />
                </div>
            </div>
            <div>
                <Label required>Master Group</Label>
                <div className="relative">
                    <select
                        className={`${inputCls} appearance-none pr-10`}
                        value={groupId}
                        onChange={(e) => onGroupChange(e.target.value)}
                        disabled={!natureGroupId || masterLoading || disabled}
                    >
                        <option value="">{!natureGroupId ? 'Select nature of group first' : masterLoading ? 'Loading…' : '-Please Select-'}</option>
                        {masterGroups.map((g) => (
                            <option key={g.GroupId} value={g.GroupId}>{g.GroupName}</option>
                        ))}
                    </select>
                    <SelectIcon loading={masterLoading} />
                </div>
            </div>
            {showSubGroup && (
                <div>
                    <Label required>Sub Group</Label>
                    <div className="relative">
                        <select
                            className={`${inputCls} appearance-none pr-10`}
                            value={subGroupId}
                            onChange={(e) => onSubGroupChange(e.target.value)}
                            disabled={subLoading || disabled}
                        >
                            <option value="">{subLoading ? 'Loading…' : '-Please Select-'}</option>
                            {subGroups.map((s) => (
                                <option key={s.Id} value={s.Id}>{s.Name}</option>
                            ))}
                        </select>
                        <SelectIcon loading={subLoading} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GroupCascadeFields;
